export default __webpack_public_path__ + "static/icon-andy-signature-38515b9160f6e342fe426b7c91792ca5.webp";